module.exports = __webpack_public_path__ + "img/LUB00400.58f046f4.png";